export { default as PDFComponent } from './PDFComponent';
